<template>
	<card-row title="Артикул">
		<v-chip
			color="primary"
			outlined
			label
			small
			class="mr-1"
		>
			{{ product.vendor_code }}
		</v-chip>
		<v-chip
			v-for="(vc, key) in product.additional_vendor_codes"
			:key="key"
			color="blue"
			class="mr-1"
			outlined
			label
			small
			close
			@click:close="handleDelete(vc)"
		>
			{{ vc.code }}
		</v-chip>
		<create-new-vendor-code
			:product="product"
			@created="updateVendorCodes"
		/>
	</card-row>
</template>

<script>
import CardRow from '@/components/base/card-row';
import CreateNewVendorCode from '@/components/products/show/create-new-vendor-code';

export default {
	name: 'AdditionalVendorCodes',
	components: { CreateNewVendorCode, CardRow },
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	methods: {
		updateVendorCodes(codes) {
			this.$emit('changed', codes);
		},
		async handleDelete(code) {
			if (!confirm(`Подтвердите удаление артикула "${code.code}"`)) return
			try {
				await this.$http.delete(`/api/v1/products/${this.product.id}/vendorCodes/${code.id}`);
				this.$emit('changed', this.product.additional_vendor_codes.filter(c => c.id !== code.id));
			} catch (e) {
				this.$notify.error('Ошибка удаления артикула');
			}
		},
	},
};
</script>

<style scoped>

</style>
